import { useState } from 'react';
import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { useFeatureFlags } from '../useFeatureFlags';
const loaderName = 'open-pdf';
export function useDownloadInvoicePdf() {
    const { api, logBI } = useStoreActions();
    const [downloading, setDownloading] = useState(false);
    const overlayContext = useOverlayContext();
    const { browser: { openNewTab } } = useIoContext();
    const apiGatewayHost = useStore((state)=>state.session.apiGatewayHost);
    const { INVOICE_PDF_SCOUT } = useFeatureFlags();
    return {
        isDownloadingInvoicePdf: downloading,
        async downloadInvoicePdf (invoiceId) {
            logBI(10565, {
                invoiceId
            });
            if (INVOICE_PDF_SCOUT) {
                openNewTab("".concat(apiGatewayHost, "/invoice-pdfs/").concat(invoiceId));
            } else {
                try {
                    setDownloading(true);
                    overlayContext.startLoader(loaderName);
                    const pdfUrl = await api.invoice.downloadPDF(invoiceId);
                    openNewTab(pdfUrl);
                } catch (e) {
                    overlayContext.showErrorToast('Unable to download invoice, please try again', 'download-invoice-pdf-failure');
                } finally{
                    setDownloading(false);
                    overlayContext.stopLoader(loaderName);
                }
            }
        }
    };
}
